<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="pdt-15 pdb-15 bg-white">
      <el-form ref="form" :model="form" label-width="90px" inline>
        <el-form-item label="提现编号">
          <el-input
            v-model="form.tixianNo"
            placeholder="请输入提现编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="form.name"
            placeholder="请输入姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            v-model="form.phone"
            placeholder="请输入联系电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="提现方式">
          <el-select v-model="form.type" placeholder="全部" clearable>
            <el-option label="现金提现" value="2"></el-option>
            <el-option label="水卡兑换" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提现时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList()">查 询</el-button>
          <el-button
            @click="
              form = {};
              getList();
            "
            >重 置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 统计 -->
    <div class="flex aic jcsb">
      <div class="flex aic fw-600 color0063ea mgt-20 mgb-20">
        <span class="mgr-50">总提现金额（元）：{{ stateForm.totalPrice }}</span>
        <span class="mgr-50">已打款（元）：{{ stateForm.paidPrice }}</span>
        <span class="mgr-50">待跟进（元）：{{ stateForm.applyPrice }}</span>
        <span class="mgr-50">已驳回（元）：{{ stateForm.failPrice }}</span>
      </div>
      <btns @exec="exec" class="mgb-20"></btns>
    </div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" stripe border>
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="withdrawNo" label="提现编号"> </el-table-column>
      <el-table-column prop="partnerName" label="姓名"> </el-table-column>
      <el-table-column prop="partnerPhone" label="电话"> </el-table-column>
      <el-table-column prop="withdrawType" label="提现方式">
        <template slot-scope="scope">
          <span
            v-text="scope.row.withdrawType == 2 ? '现金提现' : '水卡兑换'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="usingNum" label="收款账号">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="
              shoukuanForm = scope.row;
              shoukuanTan = true;
            "
            >详情</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="totalMoney" label="提现金额"> </el-table-column>
      <el-table-column prop="state" label="提现状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.state == 1
                ? '待跟进'
                : scope.row.state == 2
                ? '已到账'
                : '已驳回'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="提现时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.state !== 1"
            type="text"
            size="small"
            @click="handleDetail(scope.row)"
            >详情</el-button
          >
          <el-button
            v-if="scope.row.state == 1"
            type="text"
            size="small"
            @click="handleFllow(scope.row)"
            >跟进</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 跟进详情 -->
    <el-dialog
      title="跟进详情"
      :visible.sync="dialogVisible"
      width="30%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <div class="flex aic jcsb">
        <span>提现状态</span>
        <span>{{
          detailForm.state == 2
            ? "已到账"
            : detailForm.state == 3
            ? "已驳回"
            : "- -"
        }}</span>
      </div>
      <div class="flex aic jcsb mgt-20">
        <span>跟进时间</span>
        <span>{{ detailForm.followTime }}</span>
      </div>
      <div class="flex aic jcsb mgt-20" v-if="detailForm.state == 2">
        <span>提现金额</span>
        <span>{{ detailForm.totalMoney }}</span>
      </div>
      <div class="flex aic jcsb mgt-20">
        <span>跟进备注</span>
        <span>{{ detailForm.followRemark }}</span>
      </div>
      <div class="flex aic jcsb mgt-20" v-if="detailForm.state == 2">
        <span>跟进图片</span>
        <el-image
          style="width: 100px; height: 100px"
          :src="detailForm.paymentBill"
          :preview-src-list="srcList"
        >
        </el-image>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">已知晓</el-button>
      </span>
    </el-dialog>

    <!-- 跟进弹框 -->
    <el-dialog
      title="跟进"
      :visible.sync="followVisible"
      width="30%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <el-form
        ref="followForm"
        :rules="rules"
        :model="followForm"
        label-width="80px"
      >
        <el-form-item label="是否同意">
          <el-radio-group v-model="followForm.state">
            <el-radio label="同意"></el-radio>
            <el-radio label="驳回"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="跟进时间"
          prop="time"
          :rules="[
            {
              required: true,
              message: '请选择跟进时间',
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="followForm.time"
            format="yyyy-MM-dd"
            type="date"
            placeholder="跟进时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="提现金额"
          prop="paymentMoney"
          v-if="followForm.state == '同意'"
        >
          <el-input
            v-model="followForm.paymentMoney"
            placeholder="请输入提现金额"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="desc"
          :rules="[
            {
              required: true,
              message: '请输入备注',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            type="textarea"
            maxlength="100"
            show-word-limit
            placeholder="请输入备注"
            v-model="followForm.desc"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="followForm.state == '同意'"
          label="凭证"
          prop="photoDesc"
          :rules="[
            {
              required: true,
              message: '请上传凭证',
              trigger: 'blur',
            },
          ]"
        >
          <el-upload
            ref="upload"
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-change="handleEditChange"
            :file-list="imgList"
            :http-request="uploadFile"
            :limit="1"
            :auto-upload="true"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="imgsVisible">
            <img width="100%" :src="followForm.photoDesc" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-80" @click="followVisible = false"
          >取消</el-button
        >
        <el-button @click="followSure('followForm')">确定</el-button>
      </span>
    </el-dialog>
    <!-- 收款账户详情弹框 -->
    <el-dialog
      title="收款账户"
      :visible.sync="shoukuanTan"
      width="30%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <div class="flex aic jcsb mgb-8">
        <span>提现方式</span>
        <span>{{
          shoukuanForm.withdrawType == 2 ? "现金提现" : "水卡兑换"
        }}</span>
      </div>
      <div class="flex aic jcsb mgb-8" v-if="shoukuanForm.withdrawType == 2">
        <span>账户类型</span>
        <span>{{ shoukuanForm.paymentMethod == 1 ? "银行卡" : "支付宝" }}</span>
      </div>
      <div class="flex aic jcsb mgb-8" v-if="shoukuanForm.paymentMethod == 1">
        <span>收款方户名</span>
        <span>{{ shoukuanForm.cardName }}</span>
      </div>
      <div class="flex aic jcsb mgb-8" v-if="shoukuanForm.paymentMethod == 1">
        <span>收款方账号</span>
        <span>{{ shoukuanForm.cardNo }}</span>
      </div>
      <div class="flex aic jcsb mgb-8" v-if="shoukuanForm.paymentMethod == 1">
        <span>开户行</span>
        <span>{{ shoukuanForm.cardType }}</span>
      </div>
      <div class="flex aic jcsb mgb-8" v-if="shoukuanForm.paymentMethod == 2">
        <span>支付宝账号</span>
        <span>{{ shoukuanForm.aliNo }}</span>
      </div>
      <div class="flex aic jcsb mgb-8" v-if="shoukuanForm.withdrawType == 1">
        <span>水卡编号</span>
        <span>{{ shoukuanForm.waterCard }}</span>
      </div>
      <div class="flex aic jcsb mgb-8" v-if="shoukuanForm.withdrawType == 1">
        <span>用户电话</span>
        <span>{{ shoukuanForm.partnerPhone }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shoukuanTan = false">已知晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleAlert, handleConfirm } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    const addpayPrice = (rule, value, callback) => {
      var reg = /^[0-9]+([.]{1}[0-9]+){0,1}$/;
      if (!value) {
        callback(new Error("请输入金额"));
      } else if (!reg.test(value) || Number(value) > Number(this.totalMoney)) {
        callback(new Error("仅支持数字数输入，且不能大于用户提现金额"));
      } else {
        callback();
      }
    };
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      dialogVisible: false,
      followForm: {
        state: "同意",
        time: "",
        desc: "",
        photoDesc: "",
        paymentMoney: "",
      },
      imgsVisible: false,
      imgList: [],
      followVisible: false,
      withdrawId: null,
      detailForm: {
        state: "",
        paymentMoney: "",
        totalMoney: "",
        followRemark: "",
        paymentBill: "",
      },
      srcList: [],
      totalMoney: 0,
      rules: {
        paymentMoney: [
          { required: true, validator: addpayPrice, trigger: "blur" },
        ],
      },
      shoukuanTan: false,
      shoukuanForm: {},
      stateForm: {
        applyPrice: 0,
        failPrice: 0,
        paidPrice: 0,
        totalPrice: 0,
      },
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    export() {
      this.$api.partner
        .tixianExport({
          withdrawNo: this.form.tixianNo,
          partnerName: this.form.name,
          phone: this.form.phone,
          withdrawType: this.form.type,
          startDay: this.form.startTime,
          endDay: this.form.endTime,
        })
        .then((res) => {
          handleAlert("导出成功", "success");
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = URL.createObjectURL(res);
          link.setAttribute("download", "提现列表.xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    handleDetail(row) {
      this.detailForm = row;

      this.dialogVisible = true;
      if (row.paymentBill) {
        this.srcList = [row.paymentBill];
      }
    },
    // 跟进确定
    followSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认跟进吗?", "info")
            .then(() => {
              this.$api.partner
                .tixianFollow({
                  withdrawId: this.withdrawId,
                  followRemark: this.followForm.desc,
                  followTime: this.followForm.time,
                  paymentMoney:
                    this.followForm.state == "同意"
                      ? this.followForm.paymentMoney
                      : null,
                  paymentBill:
                    this.followForm.state == "同意"
                      ? this.followForm.photoDesc
                      : null,
                  state: this.followForm.state == "同意" ? true : false,
                })
                .then((res) => {
                  if (res.code === 200) {
                    this.getList();
                    handleAlert("跟进成功", "success");
                    this.followVisible = false;
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return;
        }
      });
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.partner
        .tixianList({
          pageNum: this.page,
          pageSize: this.pageSize,
          withdrawNo: this.form.tixianNo,
          partnerName: this.form.name,
          phone: this.form.phone,
          withdrawType: this.form.type,
          startDay: this.form.startTime,
          endDay: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
            this.getState();
          }
        });
    },
    getState() {
      this.$api.partner
        .tixianState({
          withdrawNo: this.form.tixianNo,
          partnerName: this.form.name,
          phone: this.form.phone,
          withdrawType: this.form.type,
          startDay: this.form.startTime,
          endDay: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.stateForm = res.data;
          }
        });
    },
    handleFllow(row) {
      console.log(row);
      this.followForm = {
        state: "同意",
        time: "",
        desc: "",
        photoDesc: "",
        paymentMoney: row.totalMoney,
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.followForm.clearValidate();
      });
      this.followVisible = true;
      this.withdrawId = row.id;
      this.totalMoney = row.totalMoney;
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    // 照片上传
    // 凭证图片上传------
    handlePictureCardPreview(file) {
      this.followForm.photoDesc = file.url;
      this.imgsVisible = true;
    },
    handleRemove(file, fileList) {
      this.imgList = fileList;
    },
    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then((res) => {
        if (res.code === 200) {
          this.followForm.photoDesc = res.data[0];
          this.imgList.push({
            url: res.data[0],
          });
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },
    // 图片超出张数不显示上传框
    handleEditChange(file, fileList) {
      console.log(fileList, "fileList");
      console.log(this.limitCount, "this.limitCount");
    },
  },
};
</script>

<style lang="scss" scoped></style>
